exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Sentence-module__sentence___2yb5C{padding:.75rem 1.25rem;height:100%;display:grid;align-items:center;cursor:pointer}.Sentence-module__sentence___2yb5C p{font-size:20px;transition:.2s}.Sentence-module__sentence___2yb5C p span{border-radius:2px}.Sentence-module__sentence___2yb5C .Sentence-module__word___NMYN3{padding:0 .125rem}.Sentence-module__sentence___2yb5C.Sentence-module__reading___10ztg p{font-weight:600}", ""]);

// exports
exports.locals = {
	"sentence": "Sentence-module__sentence___2yb5C",
	"word": "Sentence-module__word___NMYN3",
	"reading": "Sentence-module__reading___10ztg"
};